import { FormFieldTypes, IFormField } from 'types/forms'

export const FIRSTNAME_FIELD: IFormField = {
  labelTranslateKey: 'firstNameLabel',
  placeholderTranslateKey: 'firstNamePlaceholder',
  required: true,
  model: 'firstName',
  type: FormFieldTypes.Text,
  autocomplete: 'given-name'
}

export const LASTNAME_FIELD: IFormField = {
  labelTranslateKey: 'lastNameLabel',
  placeholderTranslateKey: 'lastNamePlaceholder',
  required: true,
  model: 'lastName',
  type: FormFieldTypes.Text,
  autocomplete: 'family-name'
}

export const ORGANISATION_FIELD: IFormField = {
  labelTranslateKey: 'companyLabel',
  placeholderTranslateKey: 'companyPlaceholder',
  model: 'organisationName',
  type: FormFieldTypes.Text,
  autocomplete: 'organization',
  required: true
}

export const EMAIL_FIELD: IFormField = {
  labelTranslateKey: 'emailAddressLabel',
  placeholderTranslateKey: 'emailAddressPlaceholder',
  required: true,
  model: 'emailAddress',
  type: FormFieldTypes.Email,
  autocomplete: 'email'
}

export const PHONE_NUMBER_FIELD: IFormField = {
  labelTranslateKey: 'phoneNumberLabel',
  placeholderTranslateKey: 'phoneNumberPlaceholder',
  model: 'phoneNumber',
  type: FormFieldTypes.Tel,
  autocomplete: 'tel'
}

export const FUNCTION_FIELD: IFormField = {
  labelTranslateKey: 'functionLabel',
  required: true,
  placeholderTranslateKey: 'functionPlaceholder',
  model: 'function',
  type: FormFieldTypes.Text
}

export const CONSENT_FIELD: IFormField = {
  labelTranslateKey: 'downloadFormConsentLabel',
  type: FormFieldTypes.Checkbox,
  model: 'agreeTerms',
  required: true
}

export const DEPARTMENT_FIELD: IFormField = {
  labelTranslateKey: 'departmentLabel',
  placeholderTranslateKey: 'departmentPlaceholder',
  type: FormFieldTypes.Dropdown,
  model: 'department',
  required: true,
  options: []
}

export const INTERESTS_FIELD: IFormField = {
  labelTranslateKey: 'interestsLabel',
  placeholderTranslateKey: 'interestsPlaceholder',
  type: FormFieldTypes.Dropdown,
  model: 'interests',
  options: [],
  multiple: true,
  required: true
}


export const COMMENTS_FIELD: IFormField = {
  labelTranslateKey: 'commentsLabel',
  placeholderTranslateKey: 'commentsPlaceholder',
  type: FormFieldTypes.Textarea,
  model: 'comments',
  required: true
}


export const VAT_NUMBER_FIELD: IFormField = {
  labelTranslateKey: 'vatNumberLabel',
  placeholderTranslateKey: 'vatNumberPlaceholder',
  type: FormFieldTypes.Text,
  model: 'vatNumber'
}

export const POSTAL_CODE_FIELD: IFormField = {
  labelTranslateKey: 'postalCodeLabel',
  placeholderTranslateKey: 'postalCodePlaceholder',
  type: FormFieldTypes.Text,
  model: 'postalCode',
  autocomplete: 'postal-code',
  required: true
}

export const STREET_HOUSE_NUMBER_FIELD: IFormField = {
  labelTranslateKey: 'streetAndHouseNumberLabel',
  placeholderTranslateKey: 'streetAndHouseNumberPlaceholder',
  type: FormFieldTypes.Text,
  model: 'streetAndHouseNumber',
  autocomplete: 'street-address',
  required: true
}

export const CITY_FIELD: IFormField = {
  labelTranslateKey: 'cityLabel',
  placeholderTranslateKey: 'cityPlaceholder',
  type: FormFieldTypes.Text,
  model: 'city',
  autocomplete: 'address-level2',
  required: true
}

export const COUNTRY_FIELD: IFormField = {
  labelTranslateKey: 'countryLabel',
  placeholderTranslateKey: 'countryPlaceholder',
  type: FormFieldTypes.Text,
  model: 'country',
  autocomplete: 'country',
  required: true
}

export const CV_FIELD: IFormField = {
  labelTranslateKey: 'cvFileLabel',
  placeholderTranslateKey: 'cvFilePlaceholder',
  type: FormFieldTypes.File,
  model: 'curriculumVitae',
  required: true
}

export const MOTIVATION_FIELD: IFormField = {
  labelTranslateKey: 'motivationFileLabel',
  placeholderTranslateKey: 'motivationFilePlaceholder',
  type: FormFieldTypes.File,
  model: 'motivationLetter',
  required: true
}

export const GENERAL_QUOTATION_FORM_FIELDS: IFormField[] = [
  FIRSTNAME_FIELD,
  LASTNAME_FIELD,
  VAT_NUMBER_FIELD,
  ORGANISATION_FIELD,
  FUNCTION_FIELD,
  EMAIL_FIELD,
  PHONE_NUMBER_FIELD
]

export const ADDRESS_FIELDS: IFormField[] = [
  POSTAL_CODE_FIELD,
  STREET_HOUSE_NUMBER_FIELD,
  CITY_FIELD,
  COUNTRY_FIELD
]

export const APPLICATION_FIELDS: IFormField[] = [
  FIRSTNAME_FIELD,
  LASTNAME_FIELD,
  EMAIL_FIELD,
  PHONE_NUMBER_FIELD,
  { ...CV_FIELD, allowedExtensions: window.APPLICATION_FORM_FILE_EXTENSIONS },
  { ...MOTIVATION_FIELD, allowedExtensions: window.APPLICATION_FORM_FILE_EXTENSIONS },
  { ...COMMENTS_FIELD, required: false },
  { ...CONSENT_FIELD, labelTranslateKey: 'applicationFormConsentLabel' }
]
